import { useState } from 'react';
import CarouselImage from './CarouselImage/CarouselImage';

const slides = [
    { text: 'Aslan', imageName: 'firat-aslan.jpg' },
    { text: 'Rodi', imageName: 'firat-rodi.JPG' },
    { text: 'Rodi', imageName: 'firat-misir.jpg' },
];

function PhotoSlides() {
    const [activeIndex, setActiveIndex] = useState(0);

    const showPrevious = () => {
        setActiveIndex((current) => (current === 0 ? slides.length - 1 : current - 1));
    };

    const showNext = () => {
        setActiveIndex((current) => (current === slides.length - 1 ? 0 : current + 1));
    };

    return (
        <div className="home-photo-carousel flex justify-center">
            <div className="relative w-full max-w-4xl overflow-hidden rounded-lg bg-[var(--bg-tertiary)] shadow-lg">
                <CarouselImage {...slides[activeIndex]} />
                <button
                    type="button"
                    className="absolute left-4 top-1/2 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-white/80 text-2xl text-neutral-900 shadow transition hover:bg-white"
                    aria-label="Previous photo"
                    onClick={showPrevious}
                >
                    ‹
                </button>
                <button
                    type="button"
                    className="absolute right-4 top-1/2 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-white/80 text-2xl text-neutral-900 shadow transition hover:bg-white"
                    aria-label="Next photo"
                    onClick={showNext}
                >
                    ›
                </button>
                <div className="absolute bottom-4 left-0 right-0 flex justify-center gap-2">
                    {slides.map((slide, index) => (
                        <button
                            key={slide.imageName}
                            type="button"
                            className={`h-2.5 w-2.5 rounded-full ${index === activeIndex ? 'bg-white' : 'bg-white/50'}`}
                            aria-label={`Show photo ${index + 1}`}
                            onClick={() => setActiveIndex(index)}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}

export default PhotoSlides;
